export default ({ amount, unit }, context) => {
	return {
		type: "duration",
		value: Object.fromEntries([[unit, amount.value]]),
		primitive: true,
	};
};
